export default __webpack_public_path__ + "static/media/mobile-and-tablet.277fc1fe.svg";